import {HttpCodes} from "../generics/httpCodes";

export const parseEmitErrorResponse = async (
  response: Response,
  emit: any
): Promise<Response> => {
  try {
    const error = await response.json();
    emit("error", { statusText: error, status: response.status });
  } catch (error) {
    emit("error", response);
  }
  return Promise.reject(response);
};

export const parseEmitSuccessResponse = async (
  response: Response | null,
  emit: any
): Promise<Response | void> => {
  if (!response) {
    emit("success", { status: HttpCodes.HTTP_NO_CONTENT });
    return;
  }
  emit("success", response);
  return response;
};

// TODO Not tested properly
export const parseErrorResponse = async (
  response: Response
): Promise<Response> => {
  try {
    const error = await response.json();
    console.log(error);
  } catch (error) {
    console.log(error);
    return Promise.reject(response);
  }
  return Promise.reject(response);
};

// TODO Not tested properly
export const parseSuccessResponse = async (
  response: Response | null
): Promise<Response | void> => {
  if (!response) {
    return;
  }
  return response;
};
